export const TypeSituationNfse = {
  pendente: "Pendente",
  em_andamento: "Em andamento",
  finalizado: "Finalizado",
  faturado: "Faturado",
  cancelado: "Cancelado",
}